<template>
  <div id="page-user-list">
    {{ /* Heading page */ }}
    <div class="header-pages-block d-md-flex justify-content-between">
      <h3 class="p-0">
        <b-icon class="mr-3" icon="person" font-scale="1.5" variant="primary"></b-icon> {{ dataPage.title }}
      </h3>
      <div>
        <router-link
            class="btn btn-dark mt-2 mt-md-0"
            :to="{ name: 'user-create' }"
        >
          Créer un utilisateur
        </router-link>
      </div>
    </div>

    <hr />

    <div class="d-md-flex justify-content-between mb-4">
      <div class="mt-2">
        Nombre d'utilisateur(s): {{ UserModule.total  }}
      </div>

      <div class="search mt-2 mt-md-0">
        <div class="d-flex">
          <div class="d-flex">
            {{ /* FILTER CENTER */ }}
            <b-dropdown
                class="dropdown-form-dashboard position-relative mr-4"
                :text="filter.center.title"
                ref="dropdown"
                variant="outline-secondary"
            >
              <b-dropdown-item
                  :value="0"
                  :key="0"
                  v-on:click="changeFilterCenter(0)"
              >
                Tout les centres
              </b-dropdown-item>
              <b-dropdown-item
                  v-for="(center) in CenterModule.centers"
                  :value="center.id"
                  :key="center.id"
                  v-on:click="changeFilterCenter(center.id)"
              >
                {{ center.city }}
              </b-dropdown-item>
            </b-dropdown>
          </div>

          <div class="input-group">
            <input type="text" class="bg-white form-control border" v-model="filter.search" placeholder="Mots-clés" v-on:keyup.enter="sendResearchRequest">
            <b-icon class="icon-x" icon="x" font-scale="1.5" v-on:click="sendResearchRequestReset"></b-icon>
            <div class="input-group-append">
              <button class="btn btn-success p-0 pl-2 pr-2" v-on:click="sendResearchRequest">
                Rechercher
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    {{ /* Table component */ }}
    <div class="loader-spinner d-flex justify-content-center flex-column text-center mt-5" v-if="loader.isLoading">
      <div class="text-center">
        <b-spinner variant="success" label="Spinning"></b-spinner>
        <div class="text-primary">Chargement en cours ...</div>
      </div>
    </div>
    <div v-else>
      <TableComponent
          v-if="UserModule.users.length !== 0"
          :headerList="configTableComponent.headerList"
          :datas="UserModule.users"
          :entityName="'shop'"
          :actionList="configTableComponent.actionList"
          :isAction="true"
          @switch="handleSwitch"
          @ordered="clickOrdered"
      />
      <div v-if="UserModule.users.length === 0">
        <div v-if="filter.search != null">
          Votre recherche n'a pas aboutie, merci de faire une autre recherche ou de cliquer sur la croix dans le champ de recherche
        </div>
        <div v-else>
          Aucun utilisateur, merci d'ajouter un utilisateur, en cliquant sur le button créer un utilisateur, en haut à droite de votre écran
        </div>
      </div>

      <div class="d-flex justify-content-end">
        <vPaginate
            v-if="UserModule.users.length > 0"
            :classes="bootstrapPaginationClasses"
            v-model="filter.page"
            :page-count="(UserModule.totalRequest > 0) ? Math.ceil(UserModule.totalRequest / filter.elemPerPage) : Math.ceil(UserModule.total / filter.elemPerPage)"
            @change="sendPaginateRequest"
        >
        </vPaginate>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      loader: {
        isLoading: false,
      },
      filter: {
        page: parseInt(this.$route.query.page) || 1,
        elemPerPage: 10,
        order: {
          index: 'id',
          order: 'DESC'
        },
        center: {
          id: null,
          title: 'Choisir un centre'
        },
        search: null,
      },
      bootstrapPaginationClasses: {
        ul: 'pagination',
        li: 'page-item',
        liActive: 'active',
        liDisable: 'disabled',
        button: 'page-link'
      },
      dataPage: {
        title: 'Utilisateurs'
      },
      configTableComponent: {
        headerList : [
          {'index' : 'id', 'name' : '#', 'align' : 'left', 'filter': true, 'order' : 'DESC'},
          {'index' : 'center', 'name' : 'Centre', 'align' : 'left', 'filter': true },
          {'index' : 'username', 'name' : 'Identifiant', 'align' : 'left', 'filter': true},
          {'index' : 'email', 'name' : 'Email', 'align' : 'left', 'filter': true },
          {'index' : 'roles', 'name' : 'Roles', 'align' : 'left', 'filter': false },
          {'index' : 'firstname', 'name' : 'Prénom', 'align' : 'left', 'filter': true },
          {'index' : 'lastname', 'name' : 'Nom', 'align' : 'left', 'filter': true },
          {'index' : 'phone', 'name' : 'Téléphone', 'align' : 'left', 'filter': false },
          {'index' : 'shop', 'name' : 'Commerce', 'align' : 'left', 'filter': true },
          {'index' : 'isActive', 'name' : 'Actif', 'align' : 'center', 'filter': false, 'switch': true }
        ],
        actionList: [
          { 'linkName': 'Modifier', 'cssClass' : 'btn-info', 'routeName' : 'user-edit', 'params' : true },
          { 'linkName' : 'Voir', 'cssClass' : 'btn-success ml-2', 'routeName' : 'user-show', 'params' : true }
        ]
      }
    }
  },
  methods: {
    /*----------------- LOADER ------------------*/
    showLoader() {
      this.loader.isLoading = true
    },
    hideLoader() {
      this.loader.isLoading = false
    },
    /*----------------- ORDER ------------------*/
    /**
     * Send request for order
     * @param order
     */
    clickOrdered(order)
    {
      this.filter.order = order

      this.$store.dispatch('fetchUsers', {
        centerId: this.filter.center.id,
        perPage: this.filter.elemPerPage,
        page: this.filter.page,
        order: order,
        search: (this.filter.search) ? this.filter.search : null
      })
    },
    /*----------------- FILTER ------------------*/
    changeFilterCenter(centerId) {
      if (centerId !== 0) {
        this.filter.center.id = centerId
        let center = this.$store.getters.getCenterById(centerId)
        this.filter.center.title = 'Centre choisi : ' + center.city
      } else {
        this.filter.center.id = null
        this.filter.center.title = 'choisir un centre'
      }

      this.$store.dispatch('fetchUsers', {
        centerId: this.filter.center.id,
        perPage: this.filter.elemPerPage,
        page: this.filter.page,
        order: (this.filter.order) ? this.filter.order : null,
        search: null
      })
        .then(() => {
          this.hideLoader()
        })
    },
    /*----------------- SEARCH ------------------*/
    /**
     * Reset research
     */
    sendResearchRequestReset()
    {
      this.showLoader()

      this.filter.search = null

      this.$store.dispatch('fetchUsers', {
        centerId: this.filter.center.id,
        perPage: this.filter.elemPerPage,
        page: this.filter.page,
        order: (this.filter.order) ? this.filter.order : null,
        search: null
      })
        .then(() => {
          this.hideLoader()
        })
    },
    /**
     * Send request for research
     */
    sendResearchRequest()
    {
      this.showLoader()

      this.$store.dispatch('fetchUsers', {
        centerId: this.filter.center.id,
        perPage: this.filter.elemPerPage,
        page: 1,
        order: (this.filter.order) ? this.filter.order : null,
        search: (this.filter.search) ? this.filter.search : null
      })
        .then(() => {
          this.hideLoader()
        })
    },
    /*----------------- PAGINATE ------------------*/
    /**
     * Send request for paginate
     */
    sendPaginateRequest()
    {
      this.showLoader()

      this.$store.dispatch('fetchUsers', {
        centerId: this.filter.center.id,
        perPage: this.filter.elemPerPage,
        page: this.filter.page,
        order: (this.filter.order) ? this.filter.order : null,
        search: (this.filter.search) ? this.filter.search : null
      })
        .then(() => {
          this.hideLoader()
        })
    },
    /*----------------- SWITCH ------------------*/
    /**
     * Handle switch (emit from table component)
     */
    handleSwitch(obj) {
      // Get user
      let user = this.$store.getters.getUserById(obj.id)

      // Security
      if(!user) {
        this.$bvToast.toast('User not found !', {
          title: 'ERREUR !',
          variant: 'danger',
          solid: true
        })
      }

      // Update is Active
      user.isActive = obj.value

      // Loader
      this.showLoader()

      // Call API
      this.$store.dispatch('updateIsActiveUser', user)
          .then(() => {
            this.hideLoader()

            this.$bvToast.toast((user.isActive) ? 'Utilisateur activé' : 'Utilisateur désactivé', {
              title: 'Utilisateur modifié avec succès',
              variant: (user.isActive) ? 'success' : 'warning',
              solid: true
            })
          })
          .catch(() => {
            this.hideLoader()
          })
    },
  },
  async created() {
    this.showLoader()

    await this.$store.dispatch('fetchUsers', {
      centerId: this.filter.center.id,
      perPage: this.filter.elemPerPage,
      page: this.filter.page,
      order: this.filter.order
    })
    .then(() => {
      this.hideLoader()
    })
  },
  computed: {
    ...mapState(['CenterModule']),
    ...mapState(['UserModule'])
  },
  components: {
    TableComponent: () => import('@/components/_shared/TableComponent'),
    vPaginate: () => import('vue-plain-pagination')
  }
}
</script>
